export default "__VITE_ASSET__BfJ8ThEN__"